import Options from "components/inputs/Options"

type Props = {
  value: string
  onChange: ({ name, value }: { name: string; value?: string }) => void
  name: string
  label?: string
  disabled?: boolean
  fullWidth?: boolean
  paperClass?: string
  inputClass?: string
  inputLabelClass?: string
  selectClass?: string
}

const allHours = [...Array(24).keys()]

export function HourPicker(props: Props) {
  const {
    value,
    name,
    label,
    disabled,
    onChange,
    fullWidth,
    paperClass,
    inputClass,
    inputLabelClass,
    selectClass,
  } = props
  const options = hourOptions(allHours)

  const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target
    onChange({ name, value })
  }

  return (
    <Options
      fullWidth={fullWidth}
      disabled={disabled}
      options={options}
      size="medium"
      name={name}
      value={value}
      onChange={handleChange}
      label={label}
      paperClass={paperClass}
      inputClass={inputClass}
      inputLabelClass={inputLabelClass}
      selectClass={selectClass}
    />
  )
}

function hourOptions(hours: Array<number>) {
  return hours.map((h) => ({
    value: twoDigitHour(h),
    label: hourLabel(h),
  }))
}

function twoDigitHour(h: number) {
  const suffix = ":00:00"
  const hours = Intl.NumberFormat(undefined, {
    minimumIntegerDigits: 2,
  }).format(h)
  return `${hours}${suffix}`
}

function hourLabel(h: number) {
  const suffix = h !== null && h < 12 ? "am" : "pm"
  const _h = h > 12 ? h - 12 : h
  return `${_h || 12}${suffix}`
}

export function hourLabelFromTime(t?: string) {
  if (!t) return ""

  const parts = t.split(":")
  if (!parts.length) return ""

  const time = Number(parts[0])
  return hourLabel(time)
}
